/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

export const forbiden = () => {
  return '/manager/403';
};

export const home = () => {
  return '/manager';
};

export const participants = (studyGid) => {
  return `/manager/participants/${studyGid}`;
};

export const participant = (participantJourneyGid) => {
  return `/manager/participant/${participantJourneyGid}`;
};

export const userManagement = () => {
  return '/manager/usermanagement';
};

export const userManagementPeople = (userId) => {
  return `/manager/usermanagement/details/${userId}`;
};

export const userManagementStudy = (studyGid) => {
  return `/manager/usermanagement/study/${studyGid}`;
};

export const userManagementStudyParticipant = (participantJourneyGid) => {
  return `/manager/usermanagement/participant/${participantJourneyGid}`;
};

export const userManagementOrgStudy = (organizationId, organizationName, studyGid) => {
  return `/manager/usermanagement/organization/${organizationId}/${organizationName}/study/${studyGid}`;
};

export const userManagementOrgStudyParticipant = (organizationId, organizationName, participantJourneyGid) => {
  return `/manager/usermanagement/organization/${organizationId}/${organizationName}/participant/${participantJourneyGid}`;
};

export const peopleDetails_peopleFlow = (userId, organizationId, organizationName) => {
  return `/manager/usermanagement/organization/${organizationId}/${organizationName}/details/${userId}`;
};

export const organization_details = (organizationId, organizationName) => {
  return `/manager/usermanagement/organization/${organizationId}/${organizationName}`;
};

export const peopleDetails_studyFlow = (studyGid, userId) => {
  return `/manager/${studyGid}/personnel/${userId}`;
};
